const LemonadMass=[
    {
        id:1,
        title:"Класичний 450мл",
        price:"80 грн",
        src: require('../img/lemonadclasic.png'),
        text:"лимонад, 7up",
    },
    {
        id:2,
        title:"М’ятний 450мл",
        price:"80 грн",
        src: require('../img/lemonadmyata.png'),
        text:"лимонад, м’ята, 7up",
    },
   // {
     //   id:3,
      //  title:"Фруктовий 450мл",
      //  price:"65 грн",
      //  src: require('../../../img/orangeLogo.png'),
     //   text:"лимонад, 7up, сироп в асортименті",
    //},

 {
       id:3,
       title:"манго маракуя 450мл",
       price:"85 грн",
       src: require('../img/maracuyasun.png'),
       text:"лимонад, 7up, сироп в асортименті",
    },

    
    {
        id:4,
        title:"Маракуя суниця 450мл",
        price:"89 грн",
        src: require('../img/maracuyasun.png'),
        text:"сироп маракуя, сироп суниця, лимон, лимонний сік, мінеральна вода",
    },
    {
        id:5,
        title:"кавун-ківі 450мл",
        price:"89 грн",
        src: require('../img/kavunkiwi.png'),
        text:"сироп ківі, сироп кавун, м'ята, лимон, лимонний сік, 7up",
    },
    
    // {
    //     id:6,
    //     title:"Огірково цитрусовий бабл 450мл",
    //     price:"89 грн",
    //     src: require('../img/ogirok.png'),
    //     text:"огірок, апельсин, медовий сироп, лимонний сік, 7up",
    // },
    //{
    // id:7,
       // title:"Чорниця мята 450мл",
       // price:"89 грн",
       // src: require('../img/chornicya.png'),
       // text:"лимонний сік, чорниця, цукровий сироп, м'ята, 7up",
   // },
    {
        id:8,
        title:"Бамбл 350мл",
        price:"70 грн",
        src: require('../img/bambl.png'),
        text:"сік на вибір, еспресо, карамельний сироп",
    },
    {
        id:9,
        title:"Фіалковий 450мл",
        price:"89 грн",
        src: require('../img/flem.png'),
        text:"сироп фіалки, лимонний сік, лимон, 7up",
    },
]

export default LemonadMass;